<template>
    <div class="container">
        <div class="row h-100 register">
            <div class="col-8 mx-auto  p-5 bg-white shadow-sm">
                <h2 class="h2 text-center pb-3">
                    Set a new password
                </h2>
                <hr class="w-25">
                <div class="row">
                    <div class="col-8 mx-auto ">
                        <p class="text-center">
                            Enter your user account's verified email address and we will send you a password reset link.
                        </p>
                        <div class="form">
                            <div class="form-group">
                                <input v-model.trim="$v.password.$model" type="password" class="form-control"
                                       :class="{'is-invalid' : $v.password.$error || errors.password.length}"
                                       placeholder="Create password">
                                <div class="invalid-feedback" v-if="!$v.password.$required">
                                    Please enter a password!
                                </div>
                                <div class="invalid-feedback" v-if="!$v.password.minLength">
                                    Password should be at least 6 characters!
                                </div>
                                <div class="invalid-feedback" v-for="(err, key) in errors.password" :key="key">{{
                                        err
                                    }}
                                </div>
                            </div>
                            <div class="form-group ">
                                <input v-model.trim="$v.confirmPassword.$model" type="password" class="form-control"
                                       :class="{'is-invalid' : $v.confirmPassword.$error}"
                                       placeholder="Confirm password">
                                <div class="invalid-feedback" v-if="!$v.confirmPassword.sameAsPassword">
                                    Please enter the same password!
                                </div>
                            </div>
                            <div class="form-group">
                                <button type="button" @click="send"
                                        class="btn btn-success btn-block btn-success-gradient">
                                    Set password
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {minLength, required, sameAs} from "vuelidate/lib/validators";
import {validationMixin} from "vuelidate";
import api from "@/utils/api";

export default {
    name: "PasswordSet",
    mixins: [validationMixin],
    data() {
        return {
            password: '',
            confirmPassword: '',
            errors: {
                password: [],
            }
        }
    },
    validations: {
        password: {
            required,
            minLength: minLength(6)
        },
        confirmPassword: {
            sameAsPassword: sameAs('password')
        },
    },
    methods: {
        send: function () {
            this.errors = {
                password: [],
            };
            
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            }
            let that = this;
            api.passwordSet(this.password, this.$route.params.code).then(() => {
                that.$toast.success("Please login with your new credentials!");
                that.$toast.success("Password changed successfully!");
                that.$router.push({name: 'Login'})
            }).catch(error => {
                if (error.response.status === 400 && error.response.data.error.code === 11111) {
                    that.errors = error.response.data.meta
                }
            })
        }
    }
}
</script>
